import React, {FC, memo} from "react";
import {StompSessionProvider, useSubscription} from "react-stomp-hooks";
import SendingMessages from "./SendingMessages";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions} from "../../store/sliceWebsocket";
import {actions as modal} from "../../store/sliceModal";
import {useDispatch, useSelector} from "react-redux";
import {config} from "../../config";
import {fetchRefreshToken} from "../../fetch/AuthRequest";
import {IUser} from "../../store/sliceUser";

type StompProps = {
    init?: () => void
    children: React.ReactElement
}
const Stomp: FC<StompProps> = ({init, children}) => {
    const dispatch = useDispatch<AppDispatch>();
    // const token: IToken = useSelector((state: IRootState) => state.token)

    function SubscribingComponent () {
        const user: IUser = useSelector((state: IRootState) => state.user.user)
    //Subscribe to /topic/test, and use handler for all received messages
    //Note that all subscriptions made through the library are automatically removed when their owning component gets unmounted.
    //If the STOMP connection itself is lost they are however restored on reconnect.
    //You can also supply an array as the first parameter, which will subscribe to all destinations in the array
    useSubscription("/topic/kettle", (message) => {
        dispatch(actions.setKettle(message.body))
    });
    useSubscription("/topic/receiver/state", (message) => {
        dispatch(actions.setReceiver(message.body))
    });
        useSubscription("/topic/receiver/netRadio", (message) => {
            dispatch(actions.setReceiverNetRadioControl(message.body))
        });
        useSubscription("/topic/receiver/usb", (message) => {
            dispatch(actions.setReceiverUsbControl(message.body))
        });

        useSubscription("/topic/temperature", (message) => {
            dispatch(actions.setTemperatureSensor(message.body))
        });

        useSubscription("/topic/relay", (message) => {
            dispatch(actions.setRelay(message.body))
        });

    useSubscription(`/topic/receiver/${user.id}/error`, (message) => {
        dispatch(modal.showError(message.body))
    });

        return <div style={{visibility: "hidden"}}/>;
}

    return (
        <div>
            <StompSessionProvider
                onConnect={() => {
                    fetchRefreshToken()
                }}
                // connectHeaders={stompHeaders()}
                url={`${config.socketUrl}`}
                //All options supported by @stomp/stompjs can be used here
            >
                <SubscribingComponent/>
                <SendingMessages init={init}/>
                {children}
            </StompSessionProvider>
        </div>
    )
}


export default memo(Stomp)

